import React__default from 'react';
import { useSunglassesEcommContext } from '../../context/SunglassesEcommContext.js';
import { CTA } from '../../../components/CTA/Cta.js';
import { useProductData } from '../../../../../context/product-context-hooks.js';

const SunglassesCTA = ()=>{
    const { activeVariant: { sku  } ,  } = useProductData();
    const { productAction , handleConfiguratorOpen  } = useSunglassesEcommContext();
    const handleConversionEvent = React__default.useCallback(()=>{
    // @TODO: handle conversion event in #
    // Possibly we will need to add this to products-details-v2
    }, []);
    const onAddToCartSuccess = React__default.useCallback(()=>{
    // @TODO: in a future story, this is where the data analytics will be triggered
    }, []);
    return /*#__PURE__*/ React__default.createElement(CTA, {
        action: productAction,
        handleConfiguratorOpen: handleConfiguratorOpen,
        handleConversionEvent: handleConversionEvent,
        addToCartConfig: {
            activeSku: sku,
            onSuccess: onAddToCartSuccess
        }
    });
};

export { SunglassesCTA };
//# sourceMappingURL=SunglassesCTA.js.map
